import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda López',
  age: 38,
  role: 'maestra integradora',
  city: 'Córdoba',
  text: 'Tengo varios alumnos con TDAH y TEA, y este megapack me cambió la rutina. Las actividades son claras, no saturan visualmente y los chicos se enganchan mucho más. El Kit de Regulación Emocional es oro puro.'
}, {
  name: 'Carolina Ruiz',
  age: 41,
  role: 'docente de primaria',
  city: 'Rosario',
  text: 'Lo que más valoro es la accesibilidad visual del material. Antes pasaba horas adaptando hojas yo misma. Ahora imprimo y aplico. Todos mis alumnos pueden participar, sin importar su ritmo.'
}, {
  name: 'Luciana Gómez',
  age: 32,
  role: 'psicopedagoga',
  city: 'Buenos Aires',
  text: 'Lo uso en consultorio y lo recomiendo a las familias. Los tableros visuales y el cuaderno de autonomía son recursos profesionales. Se nota que está pensado por alguien que entiende inclusión real.'
}];
export function TestimonialsSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-190">
      <div className="max-w-6xl mx-auto" data-id="element-191">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#F9327E]" data-id="element-192">
          Lo que dicen quienes ya usan el Megapack
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-193">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-194">
              <div className="flex mb-2" data-id="element-195">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-196" />)}
              </div>
              <p className="text-gray-700 italic mb-3 flex-grow" data-id="element-197">"{t.text}"</p>
              <div className="border-t pt-3 mt-auto" data-id="element-198">
                <p className="font-bold text-gray-900" data-id="element-199">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-200">{t.role}</p>
                <p className="text-sm text-gray-500" data-id="element-201">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}